import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class AttachmentApi {
  static async listAttachments(failureId: string): Promise<any> {
    return ApiHandler(baseURL).get(`/failures/${failureId}/attachments`);
  }

  static async downloadAttachment(
    failureId: string,
    attachmentId: string,
  ): Promise<any> {
    return ApiHandler(baseURL).get(
      `/failures/${failureId}/attachments/${attachmentId}/download`,
      {
        responseType: "blob",
      },
    );
  }

  static async deleteAttachment(
    failureId: string,
    attachmentId: string,
  ): Promise<any> {
    return ApiHandler(baseURL).delete(
      `/failures/${failureId}/attachments/${attachmentId}`,
    );
  }

  static async uploadAttachment(
    failureId: string,
    plantId: string,
    formData: FormData,
  ): Promise<any> {
    return ApiHandler(baseURL).post(
      `/failures/${failureId}/attachments?plantId=${plantId}`,
      formData,
    );
  }
}
